<template>
  <div class="page-container">
    <div class="page-body">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="getList"
      >
        <van-collapse v-model="groupActives" :border="false">
          <van-collapse-item
            v-for="groupItem in groupList"
            :key="groupItem.year"
            :title="`${groupItem.year}年`"
            :name="groupItem.year"
          >
            <div class="list">
              <div
                class="list-item"
                v-for="item in groupItem.list"
                :key="item.id"
                @click="toDetail(item)"
              >
                <div class="img-wrap">
                  <van-image
                    width="100%"
                    height="100%"
                    radius="6"
                    :src="item.coverImage"
                    fit="cover"
                  />
                  <div class="tag">{{ item.number }}</div>
                </div>

                <div class="content-wrap">
                  <div class="title">{{ item.title }}</div>
                  <div>
                    <div class="people">主讲人：{{ item.speaker }}</div>
                    <div class="time">时间：{{ item.startTime }}</div>
                  </div>
                </div>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getLectureList } from '@/api/exhibit'

export default {
  name: 'LectureIndex',
  data: () => ({
    list: [],
    pageNo: 1,
    loading: false,
    finished: false,
    groupActives: []
  }),
  computed: {
    groupList () {
      const data = []
      this.list.forEach((item) => {
        const i = data.findIndex((v) => v.year === item.year)
        if (i === -1) {
          data.push({
            year: item.year,
            list: [item]
          })
        } else {
          data[i].list.push(item)
        }
      })
      return data
    }
  },
  methods: {
    getList () {
      if (this.finished) return

      this.loading = true
      getLectureList({
        pageNo: this.pageNo,
        pageSize: 10
      })
        .then((res) => {
          if (res.success) {
            const { result } = res
            this.list = [
              ...this.list,
              ...(result.records || []).map((item) => {
                return {
                  ...item,
                  year: item.startTime.slice(0, 4)
                }
              })
            ]
            if (this.pageNo === 1 && this.groupList.length) {
              this.groupActives = [this.groupList[0].year]
            }
            this.pageNo++
            this.finished = result.pages === 0 || result.current === result.pages
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    toDetail (data) {
      if (data.externalLink) {
        window.location.href = data.externalLink
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
